import { useRef, useEffect } from 'react';

export const useSound = (soundUrl, options = {}) => {
    const audioRef = useRef(null);
    const { volume = 1, playbackRate = 1 } = options;

    useEffect(() => {
        if (soundUrl) {
            audioRef.current = new Audio(soundUrl);
            audioRef.current.volume = volume;
            audioRef.current.playbackRate = playbackRate;
        }
        
        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current = null;
            }
        };
    }, [soundUrl, volume, playbackRate]);

    const play = () => {
        if (audioRef.current) {
            audioRef.current.currentTime = 0; // Reset to start
            audioRef.current.play().catch(err => {
                console.log('Audio play failed:', err);
            });
        }
    };

    const pause = () => {
        if (audioRef.current) {
            audioRef.current.pause();
        }
    };

    const stop = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    };

    return { play, pause, stop };
};